<template>
  <div v-loading="loading" style="width: 100vw;height: 100vh">

    <!--    <changeAccount ref="changeRef"></changeAccount>-->
  </div>


</template>

<script>

import changeAccount from "@/components/ChangeAccount.vue";

export default {
  name: "transfer",
  components: {changeAccount},
  data() {
    return {
      loading: true
    }
  },
  created() {
    let id = this.$route.params.id || null
    let types = this.$route.query.type || null
    this.getToken(id, types)
  },
  methods: {
    getToken(id, types) {
      this.$http.get(this.$api.transfer.getToken, {random: id}).then((res) => {
        console.log(res.data.data)
        if (res.data.code == 200) {
          this.$auth.setToken(res.data.data.token)

          if (res.data.data.onlineBusinesses) {
            let temp = []
            //这个地方保存为账号信息，用于弹窗选择账号展示，type==1是个人，用于展示个人的那个绿色图标
            res.data.data.onlineUser.type = 1

            temp.push(res.data.data.onlineUser)
            temp = temp.concat(res.data.data.onlineBusinesses)
            console.log(temp)
            this.$auth.setAccount(JSON.stringify(temp))
            this.$router.push({
              path: types === 'productCenter' ? "/userCenter/productCenter" : "/home",
            });
          } else {
            this.$auth.removeAccount()
            this.getInfo('personal', types)
          }
        }
      })
    },
    getInfo(type, types) {
      this.$http.get(this.$api.user.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        let temp = res.data.data
        if (type == 'personal') {
          temp.type = 1
        } else {
          temp.type = 2
        }
        this.$store.commit("account/setUser", temp);
        this.$router.push({
          path: types === 'productCenter' ? "/userCenter/productCenter" : "/home",
        });
      })
    },
  }
}
</script>

<style scoped lang="less">

</style>
